import * as z from "zod";

export const SubscribeBackInStockConfirmationSchema = z.object({
  customerEmail: z
    .string()
    .describe(
      "The email that the customer will use to subscribe to the notifications",
    )
    .nullish(),
  productId: z
    .string()
    .describe(
      "The product id for the product whose notifications are being subscribed to",
    )
    .nullish(),
  variantIds: z
    .array(z.string())
    .describe("the variant id's for the product that is being subscribed to")
    .nullish(),
});
export type SubscribeBackInStockConfirmation = z.infer<
  typeof SubscribeBackInStockConfirmationSchema
>;
